export enum PageVariant {
  BUSINESS = 'business',
}
